import styled from "styled-components";
import { COLOR } from 'constants/colors';
import { CommonStyledComponentProps } from "__utils/type";

export const MintHeadingDiv = styled.div`
    text-align: left;
    left: 36px;
    text-transform: capitalize;
`;

export const MintHeadingH3 = styled.h3`
    text-align: left;
    left: 36px;
    text-transform: capitalize;
`;

export const CommonTitleDiv = styled.div`
    font-size: 16px;
    color: #212121;
    margin: 0 0 10px;
    color:#001837;
    font-size:20px;
    margin-bottom: 15px;
    border-bottom: #dfeef5 solid 1px;
	line-height: 53px;
	height: 53px;
	padding: 0;
`;

export const MintBoxDiv = styled.div<CommonStyledComponentProps>`
    border: 1px solid #80808038;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: ${(props: any) => props.isMobile ? "76%" : "91%"}%;
    background-color: ${COLOR.WHITE};
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 ${COLOR.SHADOWGREY};
    padding: 0;
    position: relative;
    min-width: 250px;
    margin-bottom: 24px;

    a {
        position: relative;
    }

`;

export const FormErrorMessageSpan = styled.span`
    &.unsetCustStyle{
        all: unset;
        color: #ff544e;
        font-size: 12px;
        display: block;
        margin-bottom: 15px;
    }
    color: #ff544e;
    font-size: 12px !important;
    display: block;
    margin-bottom: 4px;
`;

export const SuccessMessageSpan = styled.span`
    color: #00cb91;
    font-size: 12px;
    display: block;
    margin-top: 5px;
    margin-bottom: 15px;
    color: #00cb91;
`;

export const InputMintDiv = styled.div`
    input, select {
        border-radius: 2px;
        border: solid 1px ${COLOR.LIGHTGREY};
        background-color: ${COLOR.WHITE};
        padding: 10px;
        margin: 4px 0 8px 0;
        height: 40px;
        vertical-align: middle;
        -webkit-appearance: none;
    }
`;
export const CustomisedHr = styled.hr`
    background-color:#D2D5D6;
    height: 1px; 
    border: 0;
    margin-bottom: 16px;
    margin-left: 0;
`;

export const StickyFooter = styled.div`
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px;
    box-shadow: 0 2px 4px 4px #e0e0e0;
    z-index: 105;
`;
export const ClickableSpan = styled.span`
    cursor: pointer;
    color: ${COLOR.LINK};
`;

export const FormField = styled.div`
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
    label {
        font-size: 14px;
        width: 100%;
        font-weight: normal;
        color: #5c6b7e;
        margin-bottom: 5px;
    }
    input, select, textarea {
        padding: 14px 14px;
        resize: none;
        font-size: 16px;
        width: 100%;
        font-weight: normal;
        color: ${COLOR.BLACK};
        background-color: #fff;
        border: solid 1px #bfd6e1;
        border-radius: 4px;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
`;

export const WhiteCardWrapper = styled.div<CommonStyledComponentProps | any>`
    width: ${(props: any) => !props.fullWidth ? '1080px' : ''};
    margin: 0 auto;
    padding: ${(props: any) => !props.isMobile ? "0 0 16px 24px" : "16px"};
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 2px 8px ${COLOR.LIGHTGREY};
    margin-bottom: 30px;
    height: auto;
    overflow: auto;
`;

export const ColumnFlexWrapper = styled.div<any>`
    display: grid;
    column-gap: ${(props: any) => props?.gap};
    background-color: ${(props: any) => props?.bgColor};
    grid-template-columns: auto auto;
    border-radius: 8px;
    padding: 10px;
    justify-content: start;
`
export const DetailsCardContainer = styled.div<CommonStyledComponentProps>`
    margin-top: ${(props: any) => props.isMobile ? "16px" : ""};
    padding: ${(props: any) => !props.isMobile ? "48px" : "0 16px"};
    border-radius: 8px;
    margin-bottom: 60px;
    height: auto;
    overflow: auto;
    background-color: ${COLOR.WHITE};
    .greyTxt{
        color: ${COLOR.GREY3};
    }
    box-sizing: border-box;
    box-shadow:  ${(props: any) => !props.isMobile ? "" : "0px 0px 4px 1px rgba(224, 224, 224, 0.7)"};
`;

export const BoldText = styled.p`
    font-weight: 500;
`
export const MandateHr = styled.hr`
    background-color: #dfeef5
`

export const MobileWebText = styled.div<any>`
    font-size:  ${(props: any) => props.isMobile ? `${props.fonts[0]}px` : `${props.fonts[1]}px`};
`
